import { TreeNode } from "@/types/tree";

export type SectionCategory = string;

export type BarebonesSectionLibrary = {
  [key: SectionCategory]: TreeNode[];
};

let barebonesSectionLibrary: BarebonesSectionLibrary = {};

export function setBarebonesSectionLibrary(library: BarebonesSectionLibrary) {
  barebonesSectionLibrary = library;
}

export function getBarebonesSectionLibrary() {
  return barebonesSectionLibrary;
}
